import { render } from "./ListeBescPricingRulePage.vue?vue&type=template&id=2ed3c050&ts=true"
import script from "./ListeBescPricingRulePage.vue?vue&type=script&lang=ts"
export * from "./ListeBescPricingRulePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__